import {AfterViewChecked, AfterViewInit, Component, OnInit} from '@angular/core';
import {CoordinatesService} from "../coordinates.service";
import {DeploymentsService} from "../deployments.service";
import {switchMap, take} from "rxjs/operators";
import {ActivatedRoute, ParamMap, Router} from "@angular/router";
import {SiteReferenceService} from "../site-reference.service";
import {Observable} from "rxjs";
import * as moment from 'moment';
import * as bootstrap from "bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import {TimezoneService} from "../timezone.service";


@Component({
  selector: 'app-deployments-mission',
  templateUrl: './deployments-mission.component.html',
})
export class DeploymentsMissionComponent implements AfterViewInit, AfterViewChecked {

  missions: any = null;
  missionNumber: any = null;
  mission: any = null;
  missionNotFound: any = null;
  mapList: any = null;
  deploymentNumber$: Observable<number>;
  deploymentNumber: number;
  plots: any = null;
  moment = moment;
  timezone: any = null;
  fragment: string;

  constructor(
    public coordinatesService: CoordinatesService,
    private deploymentsService: DeploymentsService,
    private route: ActivatedRoute,
    private siteReference: SiteReferenceService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private timezoneService: TimezoneService) {
    this.timezone = timezoneService.timezone;
    // set deployments number and reload mission when a new mission is selected
    this.route.params.subscribe(params => {
      this.deploymentNumber = parseInt(params['deploymentNumber']);
      this.deploymentsService.getAllDeployments().then(response => {
        this.missions = response.sort((a, b) => b.deployment_number - a.deployment_number);
        this.loadMission();
      });
    });
    
    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
    });
  }

  ngOnInit(): void {
    if(!this.deploymentNumber) {
      let memDepNum = localStorage.getItem('selectedDeploymentNumber');
      if(memDepNum) {
          this.navigateTo(parseInt(memDepNum));
      }
    }
  }

  ngAfterViewInit(): void {
    this.spinner.show('spinner-glider-map');
  }

  ngAfterViewChecked(): void {
    if (this.fragment && document.querySelector('#' + this.fragment)) {
      document.querySelector('#' + this.fragment)!.scrollIntoView();
    }
  }

  navigateTo(deploymentNumber: number) {
    localStorage.setItem('selectedDeploymentNumber', deploymentNumber.toString());
    if (this.deploymentNumber) {
      this.router.navigate(['../', deploymentNumber], {relativeTo: this.route});
    } else {
      this.router.navigate(['./', deploymentNumber], {relativeTo: this.route});
    }
  }

  loadMission() {
    const vm = this;
    vm.missionNotFound = false;
    vm.mission = null;
    vm.mapList = null;

    const id: number = this.deploymentNumber;

    if (!id) {
      console.warn('No deploymentNumber, can\'t load mission');
      return;
    }

    const mission = Array.getByProperty(vm.missions, id, 'deployment_number');

    if (mission) {
      this.deploymentsService.getMissionSurfaceStatus().then(function (response) {
        const status_info = response[id];
        if (status_info && Object.entries(status_info).length) {
          mission.status_info = response[id];
        }

        vm.deploymentsService.getMissionsCoordinates([id]).then(function (response) {
          mission.info = response[id];
          vm.mission = mission;
          vm.mapList = [mission];
          vm.spinner.hide('spinner-glider-map');
        });
      });

      this.deploymentsService.getMissionNotes(id).then(response => {
        mission.notes = response.note;
      });

      vm.missionNumber = mission.deployment_number;
      this.deploymentsService.getPlotThumbnailPaths().then(response => {
        vm.plots = response[vm.missionNumber];
      });

    } else {
      vm.spinner.hide('spinner-glider-map');
      vm.missionNotFound = true;
    }
  }
}
